import { render } from "./BookingDetails.vue?vue&type=template&id=6c15c5ae&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"

import "./BookingDetails.vue?vue&type=style&index=0&id=6c15c5ae&lang=scss&scoped=true"
import "./BookingDetails.vue?vue&type=style&index=1&id=6c15c5ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c15c5ae"]])

export default __exports__